import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { SectionState } from '@shared-features/enums/layout.enum';

@Component({
  selector: 'app-entity-listing',
  templateUrl: './entity-listing.component.html',
  styleUrls: ['./entity-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityListingComponent implements OnInit {
  @Input() state: SectionState;
  @Input() emptyStateMainLabel: string;
  @Input() emptyStateSubLabel: string;
  @Input() emptyStateImagePath = 'assets/images/shipments-empty-state.svg';
  @Input() emptyStateIcon: string;
  @Input() errorStateLabel: string;
  @Input() pageSize = 0;
  @Input() pageIndex = 0;
  @Input() totalCount = 0;
  @Output() pageIndexChange = new EventEmitter();
  @Output() pageSizeChange = new EventEmitter();
  @Output() displayed = new EventEmitter();
  @Output() clear = new EventEmitter();
  @Input() selectionEnabled = false;
  @Input() isPaginationEnabled = true;
  sectionState = SectionState;

  constructor() { }

  ngOnInit(): void {
    this.displayed.emit();
  }

  onPageIndexChange(index: number): void {
    this.pageIndexChange.emit(index);
  }

  onPageSizeChange(value: number): void {
    this.pageSizeChange.emit(value);
  }

  get displayedCount(): number {
    let display = this.pageSize * this.pageIndex;
    if (display > this.totalCount) {
      display = this.totalCount;
    }
    return display;
  }
}
